var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    {
      staticClass: "list-group list-group-flush",
      attrs: { id: "locationList" },
    },
    _vm._l(_vm.locations, function (loc) {
      return _c(
        "li",
        {
          key: loc.id,
          staticClass: "list-group-item py-2",
          class: { active: loc.id == _vm.selected },
          attrs: { "data-id": loc.id },
          on: { click: _vm.onClick },
        },
        [
          _c("i", {
            staticClass: "fa",
            class: _vm.locationIconClass(loc.locationType),
          }),
          _vm._v("  " + _vm._s(loc.name) + " "),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }